export default {"src":"/_next/static/media/card-mastercard.05e59bb6.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};